<template>
  <detailTemplate :classCustom="['detail-docs', 'detailShowHistory']">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>

      <div class="header">
        <div class="docTags">
          <hc-command-state
            v-if="hcFlowInstance"
            :state="hcFlowInstance.currentStateCode"
          />
          <el-tag
            class="margin-left-10"
            v-if="hcCaseCommands && hcCaseCommands.isDuplicate"
            size="medium"
            type="warning"
            >Trùng chỉ đạo
          </el-tag>

          <hc-command-tien-do
            v-if="
              hcCaseCommands &&
                hcCaseCommands.deadline &&
                hcCaseCommands.completeDate
            "
            :deadline="hcCaseCommands.deadline"
            :nextDeadline="hcCaseCommands.nextDeadline"
            :nextDeadline2="hcCaseCommands.nextDeadline2"
            :completeDate="hcCaseCommands.completeDate"
          ></hc-command-tien-do>
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <!--thông tin chung kết luận chỉ đạo-->
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            inline-message
            label-width="200px"
          >
            <div class="group__info margin-top-10">
              <div class="content">
                <div class="form-input">
                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin chỉ đạo
                  </div>

                  <el-form-item
                    class="custom-label__input width25"
                    prop="meeting"
                    label="Cuộc họp"
                  >
                    <el-input
                      v-model="form.meeting"
                      placeholder="Cuộc họp"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      show-word-limit
                      maxlength="500"
                      type="textarea"
                      :readonly="!isAbleToCapNhatChiDao"
                      :autosize="{ minRows: 3, maxRows: 6 }"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25"
                    prop="sector"
                    label="Lĩnh vực"
                  >
                    <el-select
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      v-model="form.sector"
                      placeholder="Lĩnh vực"
                      size="medium"
                      filterable
                      clearable
                      :disabled="!isAbleToCapNhatChiDao"
                    >
                      <el-option
                        v-for="item in sectors"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <!--                  </div>-->
                  </el-form-item>

                  <hc-commands-doc-relations
                    ref="hcCommandsDocRelations"
                    v-if="
                      hcCaseCommandsCommon &&
                        hcCaseMaster &&
                        isAbleToCapNhatChiDao
                    "
                    :objectId="hcCaseCommandsCommon.id"
                    :objectType="
                      HC_DOC_RELATION.OBJECT_TYPE.HC_CASE_COMMANDS_COMMON
                    "
                    :deptId="hcCaseMaster.parentDeptId"
                    @docSelected="relatedDocSelected"
                  ></hc-commands-doc-relations>

                  <div
                    class="margin-top-10"
                    v-if="
                      hcCaseCommandsCommon &&
                        hcCaseMaster &&
                        !isAbleToCapNhatChiDao
                    "
                  >
                    <hc-commands-doc-relations-readonly
                      :objectId="hcCaseCommandsCommon.id"
                      :objectType="
                        HC_DOC_RELATION.OBJECT_TYPE.HC_CASE_COMMANDS_COMMON
                      "
                      :deptId="hcCaseMaster.parentDeptId"
                    ></hc-commands-doc-relations-readonly>
                  </div>

                  <el-form-item
                    class="custom-label__input width25 padding-top-10"
                    prop="commandsDate"
                    label="Ngày chỉ đạo"
                  >
                    <el-date-picker
                      v-model="form.commandsDate"
                      type="date"
                      size="medium"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      placeholder="dd/mm/yyyy"
                      format="dd/MM/yyyy"
                      :readonly="!isAbleToCapNhatChiDao"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <!--                  <el-form-item-->
                  <!--                    class="custom-label__input width25 padding-top-10"-->
                  <!--                    prop="finishDate"-->
                  <!--                    label="Ngày kết thúc chỉ đạo"-->
                  <!--                  >-->
                  <!--                    <el-date-picker-->
                  <!--                      v-model="form.finishDate"-->
                  <!--                      type="date"-->
                  <!--                      size="medium"-->
                  <!--                      class="style-fullWidth input-border__bottom input-border__radius__0"-->
                  <!--                      placeholder="dd/mm/yyyy"-->
                  <!--                      format="dd/MM/yyyy"-->
                  <!--                      :readonly="!isAbleToCapNhatChiDao"-->
                  <!--                    >-->
                  <!--                    </el-date-picker>-->
                  <!--                  </el-form-item>-->

                  <el-form-item
                    class="custom-label__input width25"
                    prop="conclusion"
                    label="Nội dung kết luận"
                  >
                    <el-input
                      v-model="form.conclusion"
                      type="textarea"
                      placeholder="Nội dung kết luận"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      show-word-limit
                      maxlength="5000"
                      :readonly="!isAbleToCapNhatChiDao"
                      :autosize="{ minRows: 3, maxRows: 6 }"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25"
                    prop="directiveId"
                    label="Lãnh đạo chỉ đạo"
                  >
                    <el-select
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      v-model="form.directiveId"
                      placeholder="Lãnh đạo chỉ đạo"
                      size="medium"
                      filterable
                      clearable
                      :disabled="!isAbleToCapNhatChiDao"
                    >
                      <el-option
                        v-for="item in listDirect"
                        :key="item.id"
                        :label="`${item.fullName} - ${item.positionName}`"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <!--                  </div>-->
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25"
                    prop="performId"
                    label="Lãnh đạo phụ trách"
                  >
                    <el-select
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      v-model="form.performId"
                      placeholder="Lãnh đạo phụ trách"
                      size="medium"
                      filterable
                      clearable
                      :disabled="!isAbleToCapNhatChiDao"
                    >
                      <el-option
                        v-for="item in listDirect"
                        :key="item.id"
                        :label="`${item.fullName} - ${item.positionName}`"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <!--                  </div>-->
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25"
                    prop="chuTriDeptIds"
                    label="Đơn vị chủ trì"
                  >
                    <el-select
                      v-if="isAbleToCapNhatChiDao"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      v-model="form.chuTriDeptIds"
                      placeholder="Đơn vị chủ trì"
                      size="medium"
                      filterable
                      clearable
                      multiple
                      @change="chuTriDeptIdsChanged"
                    >
                      <el-option
                        v-for="item in listDept"
                        :key="item.id"
                        :label="item.deptName"
                        :value="item.id"
                      ></el-option>
                    </el-select>

                    <el-input
                      v-else
                      v-model="chuTriDeptsLabel"
                      type="textarea"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      :readonly="true"
                      :autosize="{ minRows: 1 }"
                    ></el-input>

                    <!--                  </div>-->
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25"
                    prop="phoiHopDeptIds"
                    label="Đơn vị phối hợp"
                  >
                    <el-select
                      v-if="isAbleToCapNhatChiDao"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      v-model="form.phoiHopDeptIds"
                      placeholder="Đơn vị phối hợp"
                      size="medium"
                      filterable
                      clearable
                      multiple
                    >
                      <el-option
                        v-for="item in listDept"
                        :key="item.id"
                        :label="item.deptName"
                        :value="item.id"
                      ></el-option>
                    </el-select>

                    <el-input
                      v-else
                      v-model="phoiHopDeptsLabel"
                      type="textarea"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      :readonly="true"
                      :autosize="{ minRows: 1 }"
                    ></el-input>
                    <!--                  </div>-->
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25 padding-top-10"
                    prop="deadline"
                    label="Thời hạn hoàn thành"
                  >
                    <el-date-picker
                      v-model="form.deadline"
                      type="date"
                      size="medium"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      placeholder="dd/mm/yyyy"
                      format="dd/MM/yyyy"
                      :readonly="!isAbleToCapNhatChiDao || !!originalForm.nextDeadline"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25 margin-bottom-10"
                    label="Thời gian được gia hạn lần 1"
                    v-if="!!originalForm.deadline"
                  >
                    <el-date-picker
                      v-model="form.nextDeadline"
                      type="date"
                      size="medium"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      placeholder="dd/mm/yyyy"
                      format="dd/MM/yyyy"
                      :readonly="disableNextDeadline()"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25 margin-bottom-10"
                    label="Thời gian được gia hạn lần 2"
                    v-if="!!originalForm.nextDeadline"
                  >
                    <el-date-picker
                      v-model="form.nextDeadline2"
                      type="date"
                      size="medium"
                      class="style-fullWidth input-border__bottom input-border__radius__0"
                      placeholder="dd/mm/yyyy"
                      format="dd/MM/yyyy"
                      :readonly="disableNextDeadline2()"
                    >
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item
                    class="custom-label__input width25 margin-bottom-10"
                    prop="directionContent"
                    label="Ý kiến chỉ đạo"
                  >
                    <el-input
                      v-model="form.directionContent"
                      type="textarea"
                      placeholder="Ý kiến chỉ đạo của LĐ"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      show-word-limit
                      maxlength="2000"
                      :readonly="!isAbleToCapNhatChiDao"
                      :autosize="{ minRows: 3, maxRows: 6 }"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>

          <!--thông tin báo cáo của đơn vị-->
          <div
            class="group__info margin-top-10 padding-bottom-10"
            v-if="hcCaseCommands && hcCaseCommands.commandsStatus"
          >
            <div class="title font-size__medium">
              Báo cáo của đơn vị
              {{ donViThucHienDept ? donViThucHienDept.deptName : "" }}
            </div>

            <template v-if="isAbleToCapNhatChiDao">
              <hc-command-bao-cao-form
                :id="hcCaseCommands.id"
                v-if="hcCaseCommands"
                ref="hcCommandBaoCaoFormRef"
              ></hc-command-bao-cao-form>
            </template>

            <div v-else class="ctn">
              <div class="list-info width__100">
                <readonly-form-item>
                  <template #label
                    >Lãnh đạo đ/v phụ trách
                  </template>
                  <template #value
                    >{{
                      phuTrachCap1UserDeptRole
                        ? `${phuTrachCap1UserDeptRole.fullName} (${
                            phuTrachCap1UserDeptRole.positionName
                          } - ${phuTrachCap1UserDeptRole.deptName})`
                        : "-"
                    }}
                  </template>
                </readonly-form-item>

                <readonly-form-item>
                  <template #label
                    >Chuyên viên đ/v phụ trách
                  </template>
                  <template #value
                    >{{
                      phuTrachCap2UserDeptRole
                        ? `${phuTrachCap2UserDeptRole.fullName} (${
                            phuTrachCap2UserDeptRole.positionName
                          } - ${phuTrachCap2UserDeptRole.deptName})`
                        : "-"
                    }}
                  </template>
                </readonly-form-item>

                <readonly-form-item>
                  <template #label
                    >Tiến độ xử lý
                  </template>
                  <template #value
                    >{{
                      hcCaseCommands
                        ? getCommandStatusLabel(hcCaseCommands.commandsStatus)
                        : "-"
                    }}
                  </template>
                </readonly-form-item>

                <readonly-form-item>
                  <template #label
                    >Ngày hoàn thành
                  </template>
                  <template #value
                    >{{
                      (hcCaseCommands ? hcCaseCommands.completeDate : null)
                        | dateFormatter({
                          dateFormat: "DD/MM/YYYY",
                          nullValue: "-"
                        })
                    }}
                  </template>
                </readonly-form-item>

                <readonly-form-item>
                  <template #label
                    >Báo cáo kết quả thực hiện
                  </template>
                  <template #value
                    >{{
                      hcCaseCommands ? hcCaseCommands.progressImplement : "-"
                    }}
                  </template>
                </readonly-form-item>

                <hc-commands-doc-relations-readonly
                  v-if="hcCaseCommands"
                  :objectId="hcCaseCommands.id"
                  :objectType="HC_DOC_RELATION.OBJECT_TYPE.HC_CASE_COMMANDS"
                  :deptId="hcCaseCommands.deptId"
                ></hc-commands-doc-relations-readonly>

                <readonly-form-item
                  v-if="
                    hcCaseCommands &&
                      (hcCaseCommands.nextDeadline ||
                        hcCaseCommands.nextDeadline2)
                  "
                >
                  <template #label
                    >Ngày gia hạn hoàn thành
                  </template>
                  <template #value
                    >{{
                      (hcCaseCommands
                        ? hcCaseCommands.nextDeadline2 ||
                          hcCaseCommands.nextDeadline
                        : null)
                        | dateFormatter({
                          dateFormat: "DD/MM/YYYY",
                          nullValue: "-"
                        })
                    }}
                  </template>
                </readonly-form-item>

                <readonly-form-item>
                  <template #label
                    >Lý do chậm tiến độ
                  </template>
                  <template #value
                    >{{ hcCaseCommands ? hcCaseCommands.lateReason : "-" }}
                  </template>
                </readonly-form-item>
              </div>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div
        class="footer"
        v-if="
          isAbleToBaoCaoTienDo ||
            isAbleToCapNhatChiDao ||
            isAbleToPheDuyetHT ||
            isAbleToYeuCauBoSung ||
            isAbleToDangKyDeadline ||
            isAbleToHuyYeuCau ||
            isAbleChoYKienChiDao
        "
      >
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToBaoCaoTienDo"
              @click="baoCao"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Báo cáo
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToBaoCaoTienDo"
              @click="giaHan"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Y/c Gia hạn
            </el-button>

            <el-button
              size="medium"
              type="success"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToCapNhatChiDao"
              @click="update"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>

            <el-button
              size="medium"
              type="success"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToPheDuyetHT"
              @click="pheDuyet"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Phê duyệt
            </el-button>

            <el-button
              size="medium"
              type="success"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToYeuCauBoSung"
              @click="yeuCauBoSung"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Yêu cầu bổ sung
            </el-button>

            <el-button
              size="medium"
              type="success"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToDangKyDeadline"
              @click="dangKyDeadline"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Đăng ký hạn hoàn thành
            </el-button>

            <el-button
              size="medium"
              type="success"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToHuyYeuCau"
              @click="huyYeuCau"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Hủy KLCĐ
            </el-button>

            <el-button
              size="medium"
              type="success"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleChoYKienChiDao"
              @click="choYKienChiDao"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cho YK chỉ đạo
            </el-button>
          </div>
        </div>
      </div>

      <transition name="slide">
        <hc-commands-history
          ref="hcCommandsHistory"
          v-if="hcCaseCommands && hcCaseCommandsCommon"
          :hcCaseCommandsId="hcCaseCommands.id"
          :hcCaseCommandsCommonId="hcCaseCommandsCommon.id"
          :hcType="'KLCD'"
        ></hc-commands-history>
      </transition>

      <hc-command-bao-cao-dialog
        :isOpen="isOpenBaoCaoDialog"
        v-if="hcCaseCommands && isEnableBaoCaoDialog"
        :id="hcCaseCommands.id"
        @dialogClosed="isEnableBaoCaoDialog = false"
        @closeDialog="isOpenBaoCaoDialog = false"
        @success="baoCaoSuccess"
      />

      <hc-command-bo-sung-dialog
        :isOpen="isOpenBoSungDialog"
        v-if="hcCaseCommands && isEnableBoSungDialog"
        :id="hcCaseCommands.id"
        @dialogClosed="isEnableBoSungDialog = false"
        @closeDialog="isOpenBoSungDialog = false"
        @success="yeuCauBoSungSuccess"
      />

      <hc-command-gia-han-dialog
        :isOpen="isOpenGiaHanDialog"
        v-if="hcCaseCommands && isEnableGiaHanDialog"
        :id="hcCaseCommands.id"
        @dialogClosed="isEnableGiaHanDialog = false"
        @closeDialog="isOpenGiaHanDialog = false"
        @success="giaHanSuccess"
      />

      <hc-command-dk-deadline-dialog
        :isOpen="isOpenDkDeadlineDialog"
        v-if="hcCaseCommands && isEnableDkDeadlineDialog"
        :id="hcCaseCommands.id"
        @dialogClosed="isEnableDkDeadlineDialog = false"
        @closeDialog="isOpenDkDeadlineDialog = false"
        @success="dangKyDeadlineSuccess"
      />

      <hc-command-huy-yeu-cau-dialog
        :isOpen="isOpenHuyYeuCauDialog"
        v-if="hcCaseCommands && isEnableHuyYeuCauDialog"
        :id="hcCaseCommands.id"
        @dialogClosed="isEnableHuyYeuCauDialog = false"
        @closeDialog="isOpenHuyYeuCauDialog = false"
        @success="huyYeuCauSuccess"
      />

      <hc-command-cho-y-kien-dialog
        :isOpen="isOpenChoYKienDialog"
        v-if="hcCaseCommands && isEnableChoYKienDialog"
        :id="hcCaseCommands.id"
        @dialogClosed="isEnableChoYKienDialog = false"
        @closeDialog="isOpenChoYKienDialog = false"
        @success="choYKienSuccess"
      />
    </template>
  </detailTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import buildAttachmentURL from "../../../filters/buildAttachmentURL.js";
import constants from "../../../constants";
import HcCommandBaoCaoForm from "./hc-command-bao-cao-form";
import HcCommandStatus from "./hc-command-status";
import HcCommandStateIcon from "./hc-command-state-icon";
import HcCommandState from "./hc-command-state";
import Vue from "vue";
import hcCaseCommandsService from "../../../services/hcCaseCommandsService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import departmentService from "../../../services/departmentService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCaseCommandsCommonService from "../../../services/hcCaseCommandsCommonService";
import h from "../../../services/h";
import HcCommandBaoCaoDialog from "./hc-command-bao-cao-dialog";
import ReadonlyFormItem from "./readonly-form-item";
import hcCaseCommandsUserService from "../../../services/hcCaseCommandsUserService";
import dateFormatter from "../../../filters/dateFormatter";
import hcStateToStateService from "../../../services/hcStateToStateService";
import hcCaseMasterService from "../../../services/hcCaseMasterService";
import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
import HcCommandBoSungDialog from "./hc-command-bo-sung-dialog";
import HcCommandGiaHanDialog from "./hc-command-gia-han-dialog";
import HcCommandsDocRelations from "./hc-commands-doc-relations";
import HcCommandsDocRelationsReadonly from "./hc-commands-doc-relations-readonly";
import HcCommandsHistory from "./hc-commands-history";
import HcCommandDkDeadlineDialog from "./hc-command-dk-deadline-dialog";
import dateUtils from "../../../dateUtils";
import utils from "../../../services/utils";
import goBackMixin from "../../../mixins/goBackMixin";
import HcCommandHuyYeuCauDialog from "./hc-command-huy-yeu-cau-dialog";
import HcCommandChoYKienDialog from "./hc-command-cho-y-kien-dialog";
import HcCommandTienDo from "./hc-command-tien-do";

export default {
  mixins: [handleRequestErrorMixin, goBackMixin],
  filters: { buildAttachmentURL, dateFormatter },
  components: {
    HcCommandBaoCaoForm,
    HcCommandTienDo,
    HcCommandChoYKienDialog,
    HcCommandHuyYeuCauDialog,
    HcCommandDkDeadlineDialog,
    HcCommandsHistory,
    HcCommandsDocRelationsReadonly,
    HcCommandsDocRelations,
    HcCommandGiaHanDialog,
    HcCommandBoSungDialog,
    ReadonlyFormItem,
    HcCommandBaoCaoDialog,
    HcCommandState,
    HcCommandStateIcon,
    HcCommandStatus,
    VuePerfectScrollbar,
    detailTemplate: () => import("../../common/detail.vue"),
    fileTypeImage: () => import("../../job/FileTypeImage.vue")
  },

  data() {
    return {
      attachment: null,
      DOCUMENT_FILE: constants.DOCUMENT_FILE,
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,

      sectors: [],
      listDept: [],
      listDirect: [],
      form: {
        status: null,
        state: null,
        meeting: null,
        // progress: null,
        sector: null,
        commandsDate: null,
        finishDate: null,
        conclusion: null,
        directiveId: null,
        performId: null,
        deadline: null,
        nextDeadline: null,
        nextDeadline2: null,
        directionContent: null,
        chuTriDeptIds: null,
        phoiHopDeptIds: null
      },
      originalForm: {},
      rules: {},
      status: null,
      // noted_err: "",
      // progress_err: "",

      hcCaseCommands: null,
      hcCaseCommandsCommon: null,
      hcCaseCommandsList: null,
      isOpenBaoCaoDialog: false,
      isEnableBaoCaoDialog: false,
      phuTrachCap1UserDeptRole: null,
      phuTrachCap2UserDeptRole: null,
      donViThucHienDept: null,
      nextHcStateToStateActions: null,
      hcCaseMaster: null,
      hcFlowInstance: null,
      isAbleToCapNhatChiDao: false,
      isAbleToBaoCaoTienDo: false,
      isAbleToPheDuyetHT: false,
      isAbleToYeuCauBoSung: false,
      isAbleToDangKyDeadline: false,
      isAbleToHuyYeuCau: false,
      isAbleChoYKienChiDao: false,
      isOpenBoSungDialog: false,
      isEnableBoSungDialog: false,
      isOpenGiaHanDialog: false,
      isEnableGiaHanDialog: false,
      isEnableDkDeadlineDialog: false,
      isOpenDkDeadlineDialog: false,
      isOpenHuyYeuCauDialog: false,
      isEnableHuyYeuCauDialog: false,
      isOpenChoYKienDialog: false,
      isEnableChoYKienDialog: false,
      HC_DOC_RELATION: constants.HC_DOC_RELATION,

      chuTriDeptsLabel: null,
      phoiHopDeptsLabel: null
    };
  },

  computed: {
    caseMasterId() {
      return this.$route.params.id;
    },
    parentDeptId() {
      return this.$store.state.userDeptRoles[0].parentDeptId;
    },
    deptId() {
      return this.form.deptId;
    },
    uploadAttachmentAdditionalData() {
      return {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_BAOCAOCHIDAO
      };
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  watch: {
    isOpenBaoCaoDialog(newValue) {
      if (newValue) this.isEnableBaoCaoDialog = newValue;
    },

    isOpenBoSungDialog(newValue) {
      if (newValue) this.isEnableBoSungDialog = newValue;
    },

    isOpenGiaHanDialog(newValue) {
      if (newValue) this.isEnableGiaHanDialog = newValue;
    },

    isOpenDkDeadlineDialog(newValue) {
      if (newValue) this.isEnableDkDeadlineDialog = newValue;
    },

    isOpenHuyYeuCauDialog(newValue) {
      if (newValue) this.isEnableHuyYeuCauDialog = newValue;
    },

    isOpenChoYKienDialog(newValue) {
      if (newValue) this.isEnableChoYKienDialog = newValue;
    },

    caseMasterId() {
      this.reloadPage();
    }
  },

  created() {
    this.initSelectOptions();
    this.initPage();
  },

  methods: {
    initChuTriPhoiHopDeptsLabel() {
      let deptIds = [];

      if (this.form.phoiHopDeptIds) deptIds.push(...this.form.phoiHopDeptIds);
      if (this.form.chuTriDeptIds) deptIds.push(...this.form.chuTriDeptIds);

      return deptIds && deptIds.length
        ? departmentService.findAllByIdIn(deptIds).then(response => {
            let depts = response.data;
            let chuTriDepts = h.findAll(
              depts,
              dept => (this.form.chuTriDeptIds || []).indexOf(dept.id) !== -1
            );
            let phoiHopDepts = h.findAll(
              depts,
              dept => (this.form.phoiHopDeptIds || []).indexOf(dept.id) !== -1
            );
            this.chuTriDeptsLabel = (
              h.collect(chuTriDepts, dept => dept.deptName) || []
            ).join("\n");
            this.phoiHopDeptsLabel = (
              h.collect(phoiHopDepts, dept => dept.deptName) || []
            ).join("\n");
          })
        : Promise.resolve();
    },

    choYKienSuccess() {
      this.isOpenChoYKienDialog = false;
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    choYKienChiDao() {
      this.isOpenChoYKienDialog = true;
    },

    relatedDocSelected(event) {
      let relatedDoc = event.relatedDoc;
      if (
        relatedDoc.referenceObjectType ===
        constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC
      ) {
        this.form.commandsDate = relatedDoc.docDate;
        this.form.conclusion = relatedDoc.quote;
      }
    },

    isChiDaoChanged() {
      let chuTriDeptIds = [];
      let phoiHopDeptIds = [];
      this.collectChuTriPhoiHopDeptId(chuTriDeptIds, phoiHopDeptIds);
      return (
        this.form.status !== this.originalForm.status ||
        this.form.meeting !== this.originalForm.meeting ||
        (this.form.sector || null) !== this.originalForm.sector ||
        dateUtils.isDiff(
          this.form.commandsDate,
          this.originalForm.commandsDate
        ) ||
        dateUtils.isDiff(this.form.finishDate, this.originalForm.finishDate) ||
        this.form.conclusion !== this.originalForm.conclusion ||
        (this.form.directiveId || null) !== this.originalForm.directiveId ||
        (this.form.performId || null) !== this.originalForm.performId ||
        dateUtils.isDiff(this.form.deadline, this.originalForm.deadline) ||
        dateUtils.isDiff(this.form.nextDeadline, this.originalForm.nextDeadline) ||
        dateUtils.isDiff(this.form.nextDeadline2, this.originalForm.nextDeadline2) ||
        this.form.directionContent !== this.originalForm.directionContent ||
        utils.idDiffWithArray(this.form.chuTriDeptIds, chuTriDeptIds) ||
        utils.idDiffWithArray(this.form.phoiHopDeptIds, phoiHopDeptIds) ||
        (this.$refs.hcCommandsDocRelations &&
          this.$refs.hcCommandsDocRelations.isDataChanged()) ||
        (this.$refs.hcCommandBaoCaoFormRef &&
          this.$refs.hcCommandBaoCaoFormRef.isDataChanged())
      );
    },

    async reloadPage() {
      await this.initPage();
      await this.reloadHistories();
      await this.reloadDocRelations();
    },

    async initPage() {
      await this.loadHcCaseCommands();
      await this.loadHcCaseCommandsCommon();
      await this.loadBaoCaoDonViInfo();
      await this.loadHcCaseMaster();
      await this.loadHcFlowInstance();
      await this.loadNextActions();
      await this.loadDonViThucHien();
      await this.loadDirectiveActors();
      await this.loadDepartments();
      this.initActions();
      this.initFormForEdit();
      this.initValidationRules();
      await this.initChuTriPhoiHopDeptsLabel();
    },

    reloadHistories() {
      if (this.$refs.hcCommandsHistory)
        this.$refs.hcCommandsHistory.reloadHistories();
    },

    reloadDocRelations() {
      if (this.$refs.hcCommandsDocRelations)
        this.$refs.hcCommandsDocRelations.reloadData();
    },

    initActions() {
      this.isAbleToCapNhatChiDao =
        this.hcFlowInstance.currentStateCode !==
          constants.HC_STATE.STATE_CODE.CHI_DAO.HUY_CHI_DAO &&
        this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.TAO_KET_LUAN
        );

      /**
       * check quyền theo cấu hình luồng
       * bổ sung thêm là người nào có quyền tổng hợp báo cáo thì cũng có quyền cập nhật (trong TH cập nhật giúp đơn vị)
       */
      this.isAbleToBaoCaoTienDo =
        this.hcCaseCommands.deptId === this.userDeptRole.deptId &&
        (this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.BAO_CAO_TIEN_DO
        ) ||
          this.isEnableAction(
            constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.BAO_CAO_HOAN_THANH
          ));

      this.isAbleToPheDuyetHT = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.PHE_DUYET
      );
      this.isAbleToYeuCauBoSung = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.YEU_CAU_BO_SUNG
      );

      this.isAbleToDangKyDeadline =
        !this.hcCaseCommands.deadline &&
        this.hcCaseCommands.deptId === this.userDeptRole.deptId &&
        (this.isEnableAction(
          constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.BAO_CAO_TIEN_DO
        ) ||
          this.isEnableAction(
            constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.BAO_CAO_HOAN_THANH
          ));

      this.isAbleToHuyYeuCau = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.CHI_DAO.HUY
      );

      //lãnh đạo chỉ đạo & phụ trách được phép cho ý kiến;
      this.isAbleChoYKienChiDao =
        this.hcFlowInstance.currentStateCode !==
          constants.HC_STATE.STATE_CODE.CHI_DAO.HUY_CHI_DAO &&
        (this.userDeptRoleId === this.hcCaseCommandsCommon.directiveId ||
          this.userDeptRoleId === this.hcCaseCommandsCommon.performId);
    },

    isEnableAction(actionCode) {
      return h.exists(
        this.nextHcStateToStateActions,
        hcStateToState => hcStateToState.actionCode === actionCode
      );
    },

    loadHcFlowInstance() {
      return hcFlowInstanceService
        .findById(this.hcCaseMaster.flowInstanceId)
        .then(response => (this.hcFlowInstance = response.data));
    },

    loadHcCaseMaster() {
      return hcCaseMasterService
        .findById(this.hcCaseCommands.hcCaseMasterId)
        .then(response => (this.hcCaseMaster = response.data));
    },

    loadNextActions() {
      return hcStateToStateService
        .findAllActionsByHcCaseCommands(this.hcCaseMaster.flowInstanceId)
        .then(response => (this.nextHcStateToStateActions = response.data));
    },

    loadDonViThucHienDept() {
      departmentService
        .findById(this.hcCaseCommands.deptId)
        .then(response => (this.donViThucHienDept = response.data));
    },

    getCommandStatusLabel(commandsStatus) {
      return hanhChinhUtils.getHcCommandStatusLabel(commandsStatus);
    },

    loadBaoCaoDonViInfo() {
      return this.hcCaseCommands.commandsStatus
        ? Promise.all([
            this.loadPhuTrachUserDeptRoles(),
            this.loadDonViThucHienDept()
          ])
        : Promise.resolve();
    },

    loadPhuTrachUserDeptRoles() {
      return hcCaseCommandsUserService
        .findByHcCaseCommandsId(this.hcCaseCommands.id)
        .then(response => {
          let hcCaseCommandsUsers = response.data;
          let phuTrachCap1 = h.find(
            hcCaseCommandsUsers,
            hcCaseCommandsUser =>
              hcCaseCommandsUser.type ===
              constants.HC_CASE_COMMANDS_USER.TYPE.PHU_TRACH_CAP1
          );
          let phuTrachCap2 = h.find(
            hcCaseCommandsUsers,
            hcCaseCommandsUser =>
              hcCaseCommandsUser.type ===
              constants.HC_CASE_COMMANDS_USER.TYPE.PHU_TRACH_CAP2
          );
          return Promise.all([
            this.loadPhuTrachUserDeptRole(phuTrachCap1),
            this.loadPhuTrachUserDeptRole(phuTrachCap2)
          ]).then(userDeptRoles => {
            this.phuTrachCap1UserDeptRole = userDeptRoles[0];
            this.phuTrachCap2UserDeptRole = userDeptRoles[1];
          });
        });
    },

    loadPhuTrachUserDeptRole(hcCaseCommandsUsers) {
      return !hcCaseCommandsUsers
        ? Promise.resolve(null)
        : userDeptRoleViewService
            .findById(hcCaseCommandsUsers.userId)
            .then(response => response.data);
    },

    baoCaoSuccess() {
      this.isOpenBaoCaoDialog = false;
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    yeuCauBoSungSuccess() {
      this.isOpenBoSungDialog = false;
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    giaHanSuccess() {
      this.isOpenGiaHanDialog = false;
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    dangKyDeadlineSuccess() {
      this.isOpenDkDeadlineDialog = false;
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    huyYeuCauSuccess() {
      this.isOpenDkDeadlineDialog = false;
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    loadDonViThucHien() {
      return hcCaseCommandsService
        .findAllByHcCaseCommandsCommonId(
          this.hcCaseCommands.hcCaseCommandsCommonId
        )
        .then(response => (this.hcCaseCommandsList = response.data));
    },

    chuTriDeptIdsChanged() {
      this.$refs.form.validateField("chuTriDeptIds");
    },

    initSelectOptions() {
      // this.sectors = hanhChinhUtils.buildHcCommandSectorOptions();
      hanhChinhUtils
        .buildHcCommandSectorOptions()
        .then(sectors => (this.sectors = sectors));
    },

    loadHcCaseCommands() {
      return hcCaseCommandsService
        .findByCaseMasterId(this.caseMasterId)
        .then(response => (this.hcCaseCommands = response.data));
    },

    loadHcCaseCommandsCommon() {
      return hcCaseCommandsCommonService
        .findById(this.hcCaseCommands.hcCaseCommandsCommonId)
        .then(response => (this.hcCaseCommandsCommon = response.data));
    },

    initFormForEdit() {
      this.bindDataToForm(this.form);
      this.bindDataToForm(this.originalForm); //keep lại để disable nút cạp nhật;
    },

    bindDataToForm(form) {
      form.status = this.hcCaseCommands.status;
      form.meeting = this.hcCaseCommandsCommon.meeting;
      form.progress = this.hcCaseCommands.progress;
      form.sector = this.hcCaseCommandsCommon.sector;
      form.commandsDate = this.hcCaseCommandsCommon.commandsDate
        ? new Date(this.hcCaseCommandsCommon.commandsDate)
        : null;
      form.finishDate = this.hcCaseCommandsCommon.finishDate
        ? new Date(this.hcCaseCommandsCommon.finishDate)
        : null;
      form.conclusion = this.hcCaseCommandsCommon.conclusion;
      form.directiveId = this.hcCaseCommandsCommon.directiveId;
      form.performId = this.hcCaseCommandsCommon.performId;
      form.deadline = this.hcCaseCommands.deadline
        ? new Date(this.hcCaseCommands.deadline)
        : null;
      form.nextDeadline = this.hcCaseCommands.nextDeadline
        ? new Date(this.hcCaseCommands.nextDeadline)
        : null;
      form.nextDeadline2 = this.hcCaseCommands.nextDeadline2
        ? new Date(this.hcCaseCommands.nextDeadline2)
        : null;
      form.directionContent = this.hcCaseCommandsCommon.directionContent;

      let chuTriDeptIds = (this.form.chuTriDeptIds = []);
      let phoiHopDeptIds = (this.form.phoiHopDeptIds = []);
      this.collectChuTriPhoiHopDeptId(chuTriDeptIds, phoiHopDeptIds);
    },

    collectChuTriPhoiHopDeptId(chuTriDeptIds, phoiHopDeptIds) {
      h.each(this.hcCaseCommandsList, hcCaseCommands => {
        switch (hcCaseCommands.processType) {
          case constants.HC_CASE_COMMANDS.PROCESS_TYPE.CHU_TRI:
            chuTriDeptIds.push(hcCaseCommands.deptId);
            break;
          case constants.HC_CASE_COMMANDS.PROCESS_TYPE.PHOI_HOP:
            phoiHopDeptIds.push(hcCaseCommands.deptId);
            break;
        }
      });
    },

    initValidationRules() {
      if (this.isAbleToCapNhatChiDao) {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };

        let chuTriDeptIdsConstrains = {
          validator: (rule, value, callback) => {
            if (!value || !value.length) {
              return callback(new Error("Trường dữ liệu bắt buộc"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        };

        Vue.set(this.rules, "meeting", [defaultRequiredConstrains]);
        Vue.set(this.rules, "sector", [defaultRequiredConstrains]);
        Vue.set(this.rules, "commandsDate", [defaultRequiredConstrains]);
        Vue.set(this.rules, "conclusion", [defaultRequiredConstrains]);
        Vue.set(this.rules, "directiveId", [defaultRequiredConstrains]);
        // Vue.set(this.rules, "performId", null);
        // Vue.set(this.rules, "deptId", [defaultRequiredConstrains]);
        Vue.set(this.rules, "chuTriDeptIds", [
          defaultRequiredConstrains,
          chuTriDeptIdsConstrains
        ]);
        // Vue.set(this.rules, "deadline", [defaultRequiredConstrains]);
      } else {
        Vue.set(this.rules, "meeting", null);
        Vue.set(this.rules, "sector", null);
        Vue.set(this.rules, "commandsDate", null);
        Vue.set(this.rules, "conclusion", null);
        Vue.set(this.rules, "directiveId", null);
        // Vue.set(this.rules, "performId", null);
        Vue.set(this.rules, "chuTriDeptIds", null);
        // Vue.set(this.rules, "deadline", null);
      }
    },

    backListPage() {
      this.goBack();
    },

    /**
     * load đơn vị chủ trì
     **/
    loadDepartments() {
      return departmentService
        .findAllForHcCaseCommands(this.hcCaseCommands.parentDeptId)
        .then(response => (this.listDept = response.data));
    },

    loadDirectiveActors() {
      return userDeptRoleViewService
        .findAllForHcCommands(this.hcCaseCommands.parentDeptId)
        .then(response => (this.listDirect = response.data));
    },

    baoCao() {
      this.isOpenBaoCaoDialog = true;
    },

    yeuCauBoSung() {
      this.isOpenBoSungDialog = true;
    },

    dangKyDeadline() {
      this.isOpenDkDeadlineDialog = true;
    },

    huyYeuCau() {
      // this.$confirm("Bạn chắc chắn muốn hủy chỉ đạo ?", {
      //   confirmButtonText: "Xác nhận",
      //   cancelButtonText: "Hủy bỏ",
      //   type: "warning"
      // }).then(() => {
      this.isOpenHuyYeuCauDialog = true;
      // });
    },

    giaHan() {
      this.validateSoLanGiaHan().then(() => (this.isOpenGiaHanDialog = true));
    },

    validateSoLanGiaHan() {
      return new Promise(resolve => {
        if (
          this.hcCaseCommands.nextDeadline &&
          this.hcCaseCommands.nextDeadline2
        ) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCaseCommands.giaHanQuaSoLan"
            }),
            type: "error"
          });
          return;
        }
        resolve();
      });
    },

    pheDuyet() {
      this.$confirm("Bạn chắc chắn muốn phê duyệt hoàn thành chỉ đạo ?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      })
        .then(() => {
          return hcCaseCommandsService
            .pheDuyet(this.hcCaseCommands.id)
            .then(response => response.data)
            .catch(error => {
              this.commonHandleRequestError(error);
              throw error;
            });
        })
        .then(() => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommand.pheDuyetSuccess"
            }),
            type: "success"
          });
          this.notifyMasterForDataChange({});
          this.goBack();
        });
    },

    validateFormDataChange() {
      return new Promise(resolve => {
        if (!this.isChiDaoChanged()) {
          this.$message.error({
            message: errorMessageFilter({
              errorCode: "common.formDataNotChange"
            })
          });
        } else {
          resolve();
        }
      });
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    validateDonViThucHienIds() {
      return new Promise(resolve => {
        let isOk = !h.exists(this.form.chuTriDeptIds, deptId =>
          h.exists(this.form.phoiHopDeptIds, deptId2 => deptId === deptId2)
        );
        if (!isOk) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCaseCommands.duplicateRoleDonViThuHien"
            }),
            type: "error"
          });
        } else {
          resolve();
        }
      });
    },

    // validateActorId() {
    //   return new Promise(resolve => {
    //     if (this.form.directiveId === this.form.performId) {
    //       this.$message({
    //         message: errorMessageFilter({
    //           errorCode: "hcCaseCommands.duplicateChiDaoActor"
    //         }),
    //         type: "error"
    //       });
    //     } else {
    //       resolve();
    //     }
    //   });
    // },

    validateCommandsDateAndDeadline() {
      let currentDate = new Date(new Date().setHours(0,0,0,0));
      return new Promise(resolve => {
        if (this.form.commandsDate && this.form.deadline &&
            this.form.commandsDate.getTime() > this.form.deadline.getTime()) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommands.invalidCommandsDateAndDeadline"
            }),
            type: "error"
          });
        }
        else if (this.form.commandsDate && this.form.nextDeadline && !this.form.nextDeadline2 &&
            this.form.deadline.getTime() >= this.form.nextDeadline.getTime()) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommands.invalidDeadlineAndNextDeadline"
            }),
            type: "error"
          });
        }
        else if (this.form.commandsDate && this.form.nextDeadline && !this.form.nextDeadline2 &&
            currentDate.getTime() > this.form.nextDeadline.getTime()) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommands.invalidNextDeadlineAndNow"
            }),
            type: "error"
          });
        }
        else if (this.form.commandsDate && this.form.nextDeadline && this.form.nextDeadline2 &&
          this.form.nextDeadline.getTime() >= this.form.nextDeadline2.getTime()) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommands.invalidNextDeadlineAndNextDeadline2"
            }),
            type: "error"
          });
        }
        else if (this.form.commandsDate && this.form.nextDeadline2 &&
            currentDate.getTime() > this.form.nextDeadline2.getTime()) {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommands.invalidNextDeadline2AndNow"
            }),
            type: "error"
          });
        }
        else {
          resolve();
        }
      });
    },

    convertToSubmitForm() {
      let deptForms = [];
      h.each(this.form.chuTriDeptIds, deptId =>
        deptForms.push({
          deptId: deptId,
          processType: constants.HC_CASE_COMMANDS.PROCESS_TYPE.CHU_TRI
        })
      );
      h.each(this.form.phoiHopDeptIds, deptId =>
        deptForms.push({
          deptId: deptId,
          processType: constants.HC_CASE_COMMANDS.PROCESS_TYPE.PHOI_HOP
        })
      );

      let docRelationForms = this.$refs.hcCommandsDocRelations.getSubmitForms();
      let baoCaoForm = this.convertBaoCaoFormToSubmitForm();

      return {
        meeting: this.form.meeting,
        sector: this.form.sector,
        commandsDate: this.form.commandsDate
          ? this.form.commandsDate.getTime()
          : null,
        finishDate: this.form.finishDate
          ? this.form.finishDate.getTime()
          : null,
        conclusion: this.form.conclusion,
        directiveId: this.form.directiveId,
        performId: this.form.performId,
        // deptId: this.form.deptId,
        deptForms: deptForms,
        deadline: this.form.deadline ? this.form.deadline.getTime() : null,
        nextDeadline: this.form.nextDeadline ? this.form.nextDeadline.getTime() : null,
        nextDeadline2: this.form.nextDeadline2 ? this.form.nextDeadline2.getTime() : null,
        directionContent: this.form.directionContent,
        docRelationForms: docRelationForms,
        hcCaseCommandsId: this.hcCaseCommands.id,
        baoCaoForm: baoCaoForm
      };
    },

    validateBaoCaoForm() {
      return new Promise(resolve => {
        this.$refs.hcCommandBaoCaoFormRef == null
          ? resolve()
          : this.$refs.hcCommandBaoCaoFormRef
              .validateForm()
              .then(() => resolve());
      });
    },

    convertBaoCaoFormToSubmitForm() {
      return this.$refs.hcCommandBaoCaoFormRef
        ? this.$refs.hcCommandBaoCaoFormRef.convertToSubmitForm()
        : null;
    },

    /**
     * cập nhật yêu cầu cho người tổng hợp báo cáo;
     * @returns {Promise<void>}
     */
    update() {
      return (
        this.validateForm()
          .then(() => this.validateFormDataChange())
          .then(() => this.validateCommandsDateAndDeadline())
          .then(() => this.validateDonViThucHienIds())
          // .then(() => this.validateActorId())
          .then(() => this.validateBaoCaoForm())
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return hcCaseCommandsCommonService
              .update(this.hcCaseCommands.hcCaseCommandsCommonId, submitForm)
              .then(response => response.data);
          })
          .then(() => {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcCommand.updateSuccess"
              }),
              type: "success"
            });
            this.notifyMasterForDataChange({});
            this.goBack();
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          })
      );
    },

    disableNextDeadline() {
      return !this.isAbleToCapNhatChiDao || !!this.originalForm.nextDeadline
    },

    disableNextDeadline2() {
      return !this.isAbleToCapNhatChiDao || !!this.originalForm.nextDeadline2
    }
  }
};
</script>

<style scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/ketLuanChiDao_Detail.vue